import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/copy-link.svg";
var CopyLinkOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  CopyLinkOutline_default as default
};
